import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=9ee88f74&lang=pug&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ee88f74')) {
      api.createRecord('9ee88f74', component.options)
    } else {
      api.reload('9ee88f74', component.options)
    }
    module.hot.accept("./Home.vue?vue&type=template&id=9ee88f74&lang=pug&", function () {
      api.rerender('9ee88f74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/home/Home.vue"
export default component.exports